let retryTimer = null

export const showKBankEmbedUI = ({
  ref_id,
  merchant_id,
  orderId,
  apiKey,
  amount,
  paymentMethods = 'card',
  currency = 'THB',
  scriptUrl = 'https://dev-kpaymentgateway.kasikornbank.com/ui/v2/kpayment.min.js',
  endpoint = '/checkout',
  smartpayId = null,
  smartpayTerm = null,
}) => {
  const attributes = {
    mid: merchant_id,
    apikey: apiKey,
    amount: amount,
    currency: currency,
    paymentMethods: paymentMethods,
    showButton: false,
    smartpayId: smartpayId,
    term: smartpayTerm,
    orderId: orderId,
  }
  setValueNull(attributes)

  if (!document.getElementById('form-kbank')) {
    const form = document.createElement('form')
    const script = document.createElement('script')
    const input = document.createElement('input')

    form.method = 'POST'
    form.action = endpoint
    form.id = 'form-kbank'

    input.type = 'hidden'
    input.name = 'ref_id'
    input.value = ref_id
    input.id = 'ref_id'

    const t = new Date()
    script.id = 'kbank-script'
    script.src = `${scriptUrl}?${t.toString()}`
    script.type = 'text/javascript'

    Object.keys(attributes).map(k => {
      const val = attributes[k]
      if (val !== null) {
        script.dataset[k] = attributes[k]
      }
    })

    form.appendChild(script)
    form.appendChild(input)
    document.body.appendChild(form)

    $callUtilSuccess()
  } else {
    const form = document.getElementById('form-kbank')
    form.action = endpoint
    const input = document.getElementById('ref_id')
    input.value = ref_id

    const script = document.getElementById('kbank-script')
    Object.keys(attributes).map(k => {
      const val = attributes[k]
      if (val !== null) {
        script.dataset[k] = attributes[k]
      }
    })

    window.KPayment.show()
  }
}

export const $callUtilSuccess = () => {
  if (window.KPayment) {
    try {
      window.KPayment.create()
      window.KPayment.show()
      return true
    } catch (e) {
      return false
    }
  }

  //retry
  retryTimer = setTimeout($callUtilSuccess, 1000)
}

export const goToKBankPaymentPage = (
  vm,
  { embeds, uuid, returnRoute },
) => {
  vm.$store.dispatch('kbank/setFormKBank', { embeds, returnRoute })
  return vm.$router
    .push({ name: 'KBankPayment', params: { uuid } })
    .catch(() => {})
}

// The K-Payment v2 SDK exposes NO close()/hide()/destroy() — onClose(fn) only
// registers a merchant callback. So dismiss the overlay by replicating the
// SDK's own internal closeIframe() on the DOM, then fully reset so the next
// showKBankEmbedUI() re-initialises from its first-call branch.
export const teardownKBankEmbedUI = () => {
  if (retryTimer) {
    clearTimeout(retryTimer)
    retryTimer = null
  }

  Array.prototype.forEach.call(
    document.querySelectorAll('.payment-container[_kpayment]'),
    el =>
      // remove class 'show' to hide the overlay, then let the SDK's onClose() callback remove the iframe and reset the DOM
      el.classList.remove('show'),
  )
  document.body.classList.remove('scroll-y-hidden') // SDK's scroll lock
}

export const setValueNull = value => {
  window.KPayment?.setPublickey(value.apikey)
  window.KPayment?.setAmount(value.amount)
  window.KPayment?.setCurrency(value.currency)
  window.KPayment?.setPaymentMethods(value.paymentMethods)
  window.KPayment?.setMid(value.mid)
  window.KPayment?.setSmartpayId(value?.smartpayId)
  window.KPayment?.setOrderId(value?.orderId)
  window.KPayment?.setTerm(value?.term)
  window.KPayment?.setLang('en')
}
